import { createAction } from 'redux-act';

import * as accounts from '../../core/accounts';

export const fetchAccounts = createAction(
  'get all accounts',
);
export const fetchAccountsSuccess = createAction(
  'get all accounts success',
  (allAccounts) => allAccounts
);
export const fetchAccountsFail = createAction(
  'get all accounts fail',
  (error) => error
);

export const updateAccount = createAction(
  'update account'
);
export const updateAccountSuccess = createAction(
  'update account success'
);
export const updateAccountFail = createAction(
  'update account fail',
  (error) => error
);

export const updateAccountStatus = createAction(
  'update account status'
);
export const updateAccountStatusSuccess = createAction(
  'update account status success'
);
export const updateAccountStatusFail = createAction(
  'update account status fail',
  (error) => error
);

export const openUpdateAccount = createAction(
  'open update account modal'
);

export const closeUpdateAccount = createAction(
  'close update account modal'
);

export const sendEmailConfirmationMessage = createAction(
  'send email confirmation message',
);
export const sendEmailConfirmationMessageSuccess = createAction(
  'send email confirmation message success',
);
export const sendEmailConfirmationMessageFail = createAction(
  'send email confirmation message fail',
);

export const changeAccountStatusCheck = createAction(
  'change account status check'
);

export const changeAllAccountsStatusCheck = createAction(
  'change all accounts status check'
);

export const massUpdateAccountsStatuses = createAction(
  'mass update accounts statuses'
);
export const massUpdateAccountsStatusesSuccess = createAction(
  'mass update accounts statuses success'
);
export const massUpdateAccountsStatusesFail = createAction(
  'mass update accounts statuses fail'
);

export const openAccountApps = createAction(
  'open account apss modal'
);
export const closeAccountApps = createAction(
  'close account apps modal'
);

export const updateIsEmailConfirmed = createAction(
  'update isEmailConfirmed field for account'
);
export const updateIsEmailConfirmedSuccess = createAction(
  'update isEmailConfirmed field for account success'
);

export const reducer = {
  [fetchAccounts]: (state, payload) =>
    accounts.fetchAccounts(state, payload),
  [fetchAccountsSuccess]: (state, payload) =>
    accounts.fetchAccountsSuccess(state, payload),

  [updateAccountSuccess]: (state, payload) =>
    accounts.updateAccountSuccess(state, payload),
  [updateAccountFail]: (state, payload) =>
    accounts.updateAccountFail(state, payload),

  [updateAccountStatus]: (state, payload) =>
    accounts.updateAccountStatus(state, payload),
  [updateAccountStatusSuccess]: (state, payload) =>
    accounts.updateAccountStatusSuccess(state, payload),
  [updateAccountStatusFail]: (state, payload) =>
    accounts.updateAccountStatusFail(state, payload),

  [openUpdateAccount]: (state, payload) =>
    accounts.openUpdateAccount(state, payload),
  [closeUpdateAccount]: (state, payload) =>
    accounts.closeUpdateAccount(state, payload),

  [sendEmailConfirmationMessage]: (state, payload) =>
    accounts.sendEmailConfirmationMessage(state, payload),
  [sendEmailConfirmationMessageSuccess]: (state, payload) =>
    accounts.sendEmailConfirmationMessageSuccess(state, payload),
  [sendEmailConfirmationMessageFail]: (state, payload) =>
    accounts.sendEmailConfirmationMessageFail(state, payload),

  [changeAccountStatusCheck]: (state, payload) =>
    accounts.changeAccountStatusCheck(state, payload),
  [changeAllAccountsStatusCheck]: (state, payload) =>
    accounts.changeAllAccountsStatusCheck(state, payload),

  [massUpdateAccountsStatuses]: (state, payload) =>
    accounts.massUpdateAccountsStatuses(state, payload),
  [massUpdateAccountsStatusesSuccess]: (state, payload) =>
    accounts.massUpdateAccountsStatusesSuccess(state, payload),
  [massUpdateAccountsStatusesFail]: (state, payload) =>
    accounts.massUpdateAccountsStatusesFail(state, payload),

  [openAccountApps]: (state, payload) =>
    accounts.openAccountApps(state, payload),
  [closeAccountApps]: (state, payload) =>
    accounts.closeAccountApps(state, payload),

  [updateIsEmailConfirmed]: (state) => (state),
  [updateIsEmailConfirmedSuccess]: (state, payload) =>
    accounts.updateIsEmailConfirmedSuccess(state, payload),
};



/** WEBPACK FOOTER **
 ** ./js/redux/modules/accounts.module.js
 **/